import gql from 'graphql-tag';

/**
 * 获取浮窗数据
 */
export const fetchFloatingWindowDocument = gql`
  query floatingWindow {
    floatingWindow {
      id
      isOpen
      width
      height
      isShowAfterReceived
      floatingWindowImage
      floatingWindowImageReceived
      jumpType
      jumpValue
    }
  }
`;

/**
 * 获取浮窗优惠券记录
 */
export const fetchGetFloatingWindowCouponRecordDocument = gql`
  query getFloatingWindowCouponRecord {
    getFloatingWindowCouponRecord
  }
`;

/**
 * 获取全局分享设置
 */
export const fetchShareSettingsDocument = gql`
  query shareSettings($pageKeys: [PageKey]) {
    shareSettings(pageKeys: $pageKeys) {
      id
      pageKey
      shareTitle
      shareImg
      channelId
    }
  }
`;
